// extracted by mini-css-extract-plugin
export default {"button":"styles_button__n0pjZ","saved":"styles_saved__8fHX8"};